module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_purpose_school_skyblue-3a9e3d8682ce963c6f0a17e88930449f.svg";